import React, { Component } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import OpbItemPieChart from './OpbItemPieChart';

class OpbItem extends Component {

    render() {
        const { selectedOffice, siteCnt } = this.props;
        const { officeName, totalCnt, connectY, expireCnt, stopCnt, connectN } = selectedOffice;
        const data = [
            {
                name: "연결",
                value: connectY,
            },
            {
                name: "미연결",
                value: connectY ? expireCnt + stopCnt + connectN : expireCnt + stopCnt + connectN || 1
            },
        ];


        return (
            <div className="dashboard-opbitem">
                <OverlayTrigger placement="bottom" overlay={<Tooltip>{officeName}</Tooltip>}>
                    <div className="dashboard-opbitem-title">Display 연결 현황({officeName ? (officeName.indexOf("지사") > -1 ? officeName.slice(0, officeName.indexOf("지사")) : officeName.slice(0, 5)) : ""})</div>
                </OverlayTrigger>
                <div className="dashboard-opbitem-contents">
                    <div className="charts">
                        <OpbItemPieChart data={data} />
                    </div>
                    <div className="totalcnt">
                        <div className="" style={{ fontSize: 30 }}>{totalCnt}/{siteCnt}</div>
                        <div className="" style={{ fontSize: 10 }}>Display수/현장수</div>
                    </div>

                    <div className="dashboard-opbitem-item row">
                        <OverlayTrigger overlay={<Tooltip>정상 계약중 연결됨</Tooltip>}>
                            <div className="col col-6">
                                <div className="" style={{ fontSize: 20 }}>{connectY}</div>
                                <div className="" style={{ fontSize: 10 }}>연결</div>
                            </div>
                        </OverlayTrigger>
                        <OverlayTrigger overlay={<Tooltip>운영자에 의해 중단됨</Tooltip>}>
                            <div className="col col-6">
                                <div className="" style={{ fontSize: 20 }}>{expireCnt}</div>
                                <div className="" style={{ fontSize: 10 }}>중단</div>
                            </div>
                        </OverlayTrigger>
                        <OverlayTrigger placement="bottom" overlay={<Tooltip>정상 계약중 연결이 끊김</Tooltip>}>
                            <div className="col col-6">
                                <div className="" style={{ fontSize: 20 }}>{connectN}</div>
                                <div className="" style={{ fontSize: 10 }}>끊김</div>
                            </div>
                        </OverlayTrigger>
                        <OverlayTrigger placement="bottom" overlay={<Tooltip>계약기간이 초과됨</Tooltip>}>
                            <div className="col col-6">
                                <div className="" style={{ fontSize: 20 }}>{stopCnt}</div>
                                <div className="" style={{ fontSize: 10 }}>만료</div>
                            </div>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>
        );
    }
}

export default OpbItem;
